(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('footer-accordions')) {
    class FooterAccordions extends HTMLElement {
      connectedCallback() {
        this.mql = window.matchMedia('(min-width: 750px)');
        this.onMediaChange = this.sync.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);

        this.addEventListener('click', this.onClick);
        if (this.mql.addEventListener) {
          this.mql.addEventListener('change', this.onMediaChange);
        } else if (this.mql.addListener) {
          this.mql.addListener(this.onMediaChange);
        }
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.mql) {
          if (this.mql.removeEventListener) {
            this.mql.removeEventListener('change', this.onMediaChange);
          } else if (this.mql.removeListener) {
            this.mql.removeListener(this.onMediaChange);
          }
        }
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get items() {
        return Array.prototype.slice.call(this.querySelectorAll('details[data-footer-accordion]'));
      }

      sync() {
        const desktop = this.mql.matches;
        this.items.forEach((details) => {
          details.open = desktop;
          const summary = details.querySelector('summary');
          if (!summary) return;
          if (desktop) {
            summary.setAttribute('tabindex', '-1');
          } else {
            summary.removeAttribute('tabindex');
          }
        });
      }

      handleClick(event) {
        if (!this.mql.matches) return;
        const summary = event.target.closest('summary');
        if (summary && this.contains(summary)) event.preventDefault();
      }

      handleBlockSelect(event) {
        const target = event.target;
        if (target && target.matches && target.matches('details[data-footer-accordion]') && this.contains(target)) {
          target.open = true;
        }
      }
    }

    customElements.define('footer-accordions', FooterAccordions);
  }

  if (!customElements.get('footer-localization')) {
    class FooterLocalization extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.submitButton = this.querySelector('[data-localization-submit]');
        if (!this.select || !this.submitButton) return;
        this.initialValue = this.select.value;
        this.classList.add('is-enhanced');
        this.onChange = () => {
          this.submitButton.classList.toggle('is-visible', this.select.value !== this.initialValue);
        };
        this.select.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        if (this.select && this.onChange) this.select.removeEventListener('change', this.onChange);
      }
    }

    customElements.define('footer-localization', FooterLocalization);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('glamora-header')) {
    class GlamoraHeader extends HTMLElement {
      connectedCallback() {
        var start = () => {
          if (this.isConnected && !this._ready) this.init();
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true });
        } else {
          start();
        }
      }

      init() {
        this._ready = true;
        this.sectionId = this.dataset.sectionId;
        this.isSticky = this.dataset.sticky === 'true';
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.desktopQuery = window.matchMedia('(min-width: 990px)');

        this.menuButton = this.querySelector('[data-menu-open]');
        this.drawer = document.getElementById('MenuDrawer-' + this.sectionId);
        this.searchToggle = this.querySelector('[data-search-toggle]');
        this.searchPanel = this.querySelector('[data-search-panel]');
        this.searchInput = this.querySelector('[data-search-input]');
        this.megaItems = Array.prototype.slice.call(this.querySelectorAll('[data-mega-item]'));

        this._onDocumentClick = this.onDocumentClick.bind(this);
        this._onDocumentKeydown = this.onDocumentKeydown.bind(this);
        document.addEventListener('click', this._onDocumentClick);
        document.addEventListener('keydown', this._onDocumentKeydown);

        this.initHeight();
        if (this.isSticky) this.initScroll();
        this.initMega();
        this.initSearch();
        this.initDrawer();
        this.initEditor();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this._onDocumentClick);
        document.removeEventListener('keydown', this._onDocumentKeydown);
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this._drawerObserver) this._drawerObserver.disconnect();
        if (this._onBreakpoint && this.desktopQuery && this.desktopQuery.removeEventListener) {
          this.desktopQuery.removeEventListener('change', this._onBreakpoint);
        }
        if (this.drawer && this.drawer.parentElement === document.body) {
          if (this.drawer.classList.contains('is-open')) this.closeDrawer();
          this.drawer.remove();
        }
        this._ready = false;
      }

      /* Header height -> --header-height (and sticky offset) on :root */
      initHeight() {
        var root = document.documentElement;
        this._updateHeight = () => {
          var height = Math.round(this.getBoundingClientRect().height);
          root.style.setProperty('--header-height', height + 'px');
          root.style.setProperty('--header-offset', (this.isSticky ? height : 0) + 'px');
        };
        this._updateHeight();
        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(this._updateHeight);
          this._resizeObserver.observe(this);
        } else {
          this._onResize = this._updateHeight;
          window.addEventListener('resize', this._onResize);
        }
      }

      /* Hairline border once the sticky header leaves the top of the page */
      initScroll() {
        var ticking = false;
        var update = () => {
          ticking = false;
          this.classList.toggle('is-scrolled', window.scrollY > 4);
        };
        this._onScroll = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(update);
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        update();
      }

      /* ---------- Mega menu ---------- */
      initMega() {
        this.megaItems.forEach((item) => {
          var toggle = item.querySelector('[data-mega-toggle]');
          if (!toggle) return;

          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            var isOpen = item.classList.contains('is-open');
            if (isOpen && item._openedByHover) {
              /* Opened by hover a moment ago: a click confirms it instead of closing it. */
              item._openedByHover = false;
              return;
            }
            this.setMega(item, !isOpen);
          });

          item.addEventListener('mouseenter', () => {
            if (!this.hoverQuery.matches) return;
            window.clearTimeout(this._megaCloseTimer);
            window.clearTimeout(this._megaOpenTimer);
            this._megaOpenTimer = window.setTimeout(() => {
              if (!item.classList.contains('is-open')) {
                this.setMega(item, true);
                item._openedByHover = true;
              }
            }, 80);
          });

          item.addEventListener('mouseleave', () => {
            if (!this.hoverQuery.matches) return;
            window.clearTimeout(this._megaOpenTimer);
            this._megaCloseTimer = window.setTimeout(() => this.setMega(item, false), 180);
          });

          item.addEventListener('focusout', (event) => {
            var next = event.relatedTarget;
            if (next && !item.contains(next)) this.setMega(item, false);
          });

          item.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowDown') return;
            if (!event.target.matches('[data-mega-toggle], [data-mega-link]')) return;
            event.preventDefault();
            this.setMega(item, true);
            var first = item.querySelector('[data-mega-panel] a[href]');
            if (first) window.requestAnimationFrame(() => first.focus());
          });
        });
      }

      setMega(item, open) {
        if (open) {
          this.megaItems.forEach((other) => {
            if (other !== item && other.classList.contains('is-open')) this.setMega(other, false);
          });
          this.closeSearch();
        }
        item.classList.toggle('is-open', open);
        item._openedByHover = false;
        var toggle = item.querySelector('[data-mega-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.syncPanelState();
      }

      closeAllMega() {
        this.megaItems.forEach((item) => {
          if (item.classList.contains('is-open')) this.setMega(item, false);
        });
      }

      openMegaItem() {
        for (var i = 0; i < this.megaItems.length; i++) {
          if (this.megaItems[i].classList.contains('is-open')) return this.megaItems[i];
        }
        return null;
      }

      syncPanelState() {
        this.classList.toggle('has-open-panel', !!this.openMegaItem() || this.isSearchOpen());
      }

      /* ---------- Search panel ---------- */
      initSearch() {
        if (!this.searchToggle || !this.searchPanel) return;

        this.searchToggle.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.isSearchOpen()) this.closeSearch();
          else this.openSearch();
        });

        var closeButton = this.searchPanel.querySelector('[data-search-close]');
        if (closeButton) closeButton.addEventListener('click', () => this.closeSearch());

        this.searchPanel.addEventListener('focusout', (event) => {
          var next = event.relatedTarget;
          if (next && !this.searchPanel.contains(next) && next !== this.searchToggle) this.closeSearch();
        });

        this.initPredictive();
      }

      isSearchOpen() {
        return !!this.searchPanel && this.searchPanel.classList.contains('is-open');
      }

      openSearch() {
        if (!this.searchPanel) return;
        this.closeAllMega();
        this.searchPanel.classList.add('is-open');
        this.searchToggle.setAttribute('aria-expanded', 'true');
        this.syncPanelState();
        window.requestAnimationFrame(() => {
          if (!this.searchInput || !this.isSearchOpen()) return;
          try {
            this.searchInput.focus({ preventScroll: true });
          } catch (e) {
            this.searchInput.focus();
          }
          if (this.searchInput.value) this.searchInput.select();
        });
      }

      closeSearch() {
        if (!this.isSearchOpen()) return;
        var hadFocus = this.searchPanel.contains(document.activeElement);
        this.searchPanel.classList.remove('is-open');
        this.searchToggle.setAttribute('aria-expanded', 'false');
        this.syncPanelState();
        if (hadFocus) this.searchToggle.focus();
      }

      /* ---------- Predictive search (Shopify /search/suggest.json) ---------- */
      initPredictive() {
        this.predictive = this.searchPanel.querySelector('[data-predictive-results]');
        this.predictiveStatus = this.searchPanel.querySelector('[data-predictive-status]');
        if (!this.predictive || !this.searchInput || !window.fetch) return;

        var timer;
        this.searchInput.addEventListener('input', () => {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => this.fetchPredictive(this.searchInput.value.trim()), 280);
        });
      }

      fetchPredictive(query) {
        if (this._predictiveController) this._predictiveController.abort();
        if (query.length < 2) {
          this.renderPredictive(query, null);
          return;
        }

        var controller = 'AbortController' in window ? new AbortController() : null;
        this._predictiveController = controller;
        var params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'product');
        params.set('resources[limit]', '4');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');

        var url = (this.predictive.dataset.url || '/search/suggest') + '.json?' + params.toString();
        fetch(url, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: controller ? controller.signal : undefined
        })
          .then((response) => {
            if (!response.ok) throw new Error('Predictive search failed (' + response.status + ')');
            return response.json();
          })
          .then((data) => {
            if (this.searchInput.value.trim() !== query) return;
            var results = data && data.resources && data.resources.results;
            this.renderPredictive(query, (results && results.products) || []);
          })
          .catch((error) => {
            if (error && error.name === 'AbortError') return;
            this.renderPredictive(query, null);
          });
      }

      toCents(value) {
        if (value === null || value === undefined || value === '') return null;
        if (typeof value === 'number') return Math.round(value);
        var parsed = parseFloat(String(value).replace(/[^0-9.\-]/g, ''));
        if (isNaN(parsed)) return null;
        return Math.round(parsed * 100);
      }

      money(cents) {
        var G = window.Glamora;
        var text = G && typeof G.formatMoney === 'function' ? G.formatMoney(cents) : (cents / 100).toFixed(2);
        return String(text).replace(/<[^>]*>/g, '');
      }

      sizedImage(src, width) {
        if (!src) return '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      }

      setStatus(text) {
        if (this.predictiveStatus) this.predictiveStatus.textContent = text || '';
      }

      renderPredictive(query, products) {
        var box = this.predictive;
        if (!box) return;
        box.textContent = '';

        if (!query || query.length < 2 || products === null) {
          box.hidden = true;
          this.setStatus('');
          return;
        }
        box.hidden = false;

        if (!products.length) {
          var empty = document.createElement('p');
          empty.className = 'predictive__empty';
          empty.textContent = (box.dataset.noResults || '').replace('[terms]', query);
          box.appendChild(empty);
          this.setStatus(empty.textContent);
          return;
        }

        var heading = document.createElement('p');
        heading.className = 'predictive__heading';
        heading.textContent = box.dataset.heading || '';
        box.appendChild(heading);

        var list = document.createElement('ul');
        list.className = 'predictive__list';
        list.setAttribute('role', 'list');

        products.forEach((product) => {
          var li = document.createElement('li');
          var link = document.createElement('a');
          link.className = 'predictive__item';
          link.href = product.url;

          var media = document.createElement('span');
          media.className = 'predictive__media';
          var src = (product.featured_image && product.featured_image.url) || product.image;
          if (src) {
            var img = document.createElement('img');
            img.src = this.sizedImage(src, 160);
            img.alt = '';
            img.width = 56;
            img.height = 75;
            img.loading = 'lazy';
            media.appendChild(img);
          }

          var info = document.createElement('span');
          var title = document.createElement('span');
          title.className = 'predictive__title';
          title.textContent = product.title || '';
          info.appendChild(title);

          var price = this.toCents(product.price_min !== undefined ? product.price_min : product.price);
          var priceMax = this.toCents(product.price_max);
          var compare = this.toCents(product.compare_at_price_max);
          if (price !== null) {
            var priceRow = document.createElement('span');
            priceRow.className = 'predictive__price';
            var current = document.createElement('span');
            var formatted = this.money(price);
            if (priceMax !== null && priceMax > price) {
              formatted = (box.dataset.from || '[price]').replace('[price]', formatted);
            }
            // Only show a "was" price when all variants share one price; otherwise the
            // highest compare-at would be paired with the lowest price (misleading).
            var priceVaries = priceMax !== null && priceMax > price;
            if (!priceVaries && compare !== null && compare > price) {
              var saleLabel = document.createElement('span');
              saleLabel.className = 'visually-hidden';
              saleLabel.textContent = box.dataset.saleLabel || '';
              current.className = 'price__sale';
              current.textContent = formatted;
              var regularLabel = document.createElement('span');
              regularLabel.className = 'visually-hidden';
              regularLabel.textContent = box.dataset.regularLabel || '';
              var was = document.createElement('s');
              was.className = 'price__compare';
              was.textContent = this.money(compare);
              priceRow.appendChild(saleLabel);
              priceRow.appendChild(current);
              priceRow.appendChild(regularLabel);
              priceRow.appendChild(was);
            } else {
              current.textContent = formatted;
              priceRow.appendChild(current);
            }
            info.appendChild(priceRow);
          }

          link.appendChild(media);
          link.appendChild(info);
          li.appendChild(link);
          list.appendChild(li);
        });
        box.appendChild(list);

        var all = document.createElement('button');
        all.type = 'submit';
        all.className = 'link predictive__all';
        all.textContent = box.dataset.viewAll || '';
        box.appendChild(all);

        var countTemplate = products.length === 1 ? box.dataset.countOne : box.dataset.countOther;
        this.setStatus((countTemplate || '').replace('[count]', products.length));
      }

      /* ---------- Mobile drawer ---------- */
      initDrawer() {
        if (!this.drawer || !this.menuButton) return;
        if (this.drawer.parentElement !== document.body) document.body.appendChild(this.drawer);

        this.menuButton.addEventListener('click', (event) => {
          this.closeSearch();
          this.closeAllMega();
          if (!(window.Glamora && typeof window.Glamora.openDrawer === 'function')) {
            event.preventDefault();
            this.openDrawer();
          }
        });

        this.drawer.addEventListener('click', (event) => {
          var closer = event.target instanceof Element ? event.target.closest('[data-drawer-close]') : null;
          if (closer && !(window.Glamora && typeof window.Glamora.closeDrawer === 'function')) {
            event.preventDefault();
            this.closeDrawer();
          }

          var toggle = event.target instanceof Element ? event.target.closest('[data-accordion-toggle]') : null;
          if (!toggle) return;
          var panel = document.getElementById(toggle.getAttribute('aria-controls'));
          var open = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.hidden = !open;
        });

        this.drawer.addEventListener('keydown', (event) => {
          if ((event.key === 'Escape' || event.key === 'Esc') && !window.Glamora) this.closeDrawer();
        });

        if ('MutationObserver' in window) {
          this._drawerObserver = new MutationObserver(() => {
            var open = this.drawer.classList.contains('is-open');
            this.menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
          this._drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        }

        this._onBreakpoint = () => {
          this.closeAllMega();
          if (this.desktopQuery.matches && this.drawer.classList.contains('is-open')) this.closeDrawer();
        };
        if (this.desktopQuery.addEventListener) this.desktopQuery.addEventListener('change', this._onBreakpoint);
      }

      openDrawer() {
        if (!this.drawer) return;
        var G = window.Glamora;
        if (G && typeof G.openDrawer === 'function') {
          G.openDrawer(this.drawer, this.menuButton);
          return;
        }
        this.drawer.classList.add('is-open');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.menuButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('is-locked');
        var overlay = document.getElementById('DrawerOverlay');
        if (overlay) overlay.classList.add('is-open');
        var first = this.drawer.querySelector('button, a[href]');
        if (first) window.requestAnimationFrame(() => first.focus());
      }

      closeDrawer() {
        if (!this.drawer) return;
        var G = window.Glamora;
        if (G && typeof G.closeDrawer === 'function') {
          G.closeDrawer(this.drawer);
          return;
        }
        var hadFocus = this.drawer.contains(document.activeElement);
        this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.menuButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('is-locked');
        var overlay = document.getElementById('DrawerOverlay');
        if (overlay) overlay.classList.remove('is-open');
        if (hadFocus) this.menuButton.focus();
      }

      /* ---------- Document level: outside click + Escape ---------- */
      onDocumentClick(event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        if (this.contains(target)) {
          this.megaItems.forEach((item) => {
            if (item.classList.contains('is-open') && !item.contains(target)) this.setMega(item, false);
          });
          return;
        }
        this.closeAllMega();
        this.closeSearch();
      }

      onDocumentKeydown(event) {
        if (event.key !== 'Escape' && event.key !== 'Esc') return;
        if (this.isSearchOpen()) {
          this.closeSearch();
          return;
        }
        var open = this.openMegaItem();
        if (!open) return;
        var restore = open.contains(document.activeElement);
        this.setMega(open, false);
        var toggle = open.querySelector('[data-mega-toggle]');
        if (restore && toggle) toggle.focus();
      }

      /* ---------- Theme editor ---------- */
      initEditor() {
        if (!(window.Shopify && window.Shopify.designMode)) return;

        this.addEventListener('shopify:block:select', (event) => {
          var item = event.target.closest ? event.target.closest('[data-mega-item]') : null;
          if (!item) return;
          if (this.desktopQuery.matches) {
            this.setMega(item, true);
          }
        });

        this.addEventListener('shopify:block:deselect', () => this.closeAllMega());
      }
    }

    customElements.define('glamora-header', GlamoraHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  if (!customElements.get('password-toggle')) {
    class PasswordToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-password-toggle]');
        if (!this.button) return;
        this.panel = document.getElementById(this.button.getAttribute('aria-controls'));
        if (!this.panel) return;

        this.onClick = this.toggle.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.button.addEventListener('click', this.onClick);
        this.panel.addEventListener('keydown', this.onKeydown);

        if (this.panel.hasAttribute('data-has-error')) {
          this.setOpen(true);
          this.focusInput();
        }
      }

      disconnectedCallback() {
        if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
        if (this.panel && this.onKeydown) this.panel.removeEventListener('keydown', this.onKeydown);
      }

      setOpen(open) {
        this.button.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.panel.classList.toggle('is-open', open);
      }

      focusInput() {
        const input = this.panel.querySelector('input[type="password"]');
        if (input) input.focus();
      }

      toggle() {
        const open = this.button.getAttribute('aria-expanded') !== 'true';
        this.setOpen(open);
        if (open) this.focusInput();
      }

      handleKeydown(event) {
        if (event.key !== 'Escape') return;
        this.setOpen(false);
        this.button.focus();
      }
    }

    customElements.define('password-toggle', PasswordToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!('customElements' in window) || window.customElements.get('product-carousel-marquee')) return;

    /* Pauses the auto-scrolling image row when tapped (touch screens have no hover) and while it is
       off screen. Mouse hover and keyboard focus pause it through CSS.
       A tap works like the pause button (snippets/motion-toggle.liquid, global.js): it toggles
       .is-user-paused on the row and keeps the button's state in sync.
       A tap also focuses the row and leaves a sticky :hover, which the CSS pause rules would keep
       matching; .is-touch-playing lets a second tap resume it. Moving a real mouse over the row
       drops that class again, so hover pauses on hybrid touch + mouse devices too. */
    class ProductCarouselMarquee extends HTMLElement {
      connectedCallback() {
        this.marquee = this.querySelector('[data-marquee]');
        if (!this.marquee || this.ready) return;
        this.ready = true;
        this.onPointerUp = (event) => {
          if (event.pointerType === 'mouse') return;
          const toggle = this.querySelector('[data-motion-toggle]');
          if (toggle) {
            toggle.click();
          } else {
            this.marquee.classList.toggle('is-user-paused');
          }
          this.marquee.classList.toggle('is-touch-playing', !this.marquee.classList.contains('is-user-paused'));
        };
        this.onPointerOver = (event) => {
          if (event.pointerType === 'mouse') this.marquee.classList.remove('is-touch-playing');
        };
        this.marquee.addEventListener('pointerup', this.onPointerUp);
        this.marquee.addEventListener('pointerover', this.onPointerOver);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.marquee.classList.toggle('is-offscreen', !entry.isIntersecting);
                if (entry.isIntersecting) this.loadImages();
              });
            },
            { rootMargin: '300px 0px' }
          );
          this.observer.observe(this.marquee);
        } else {
          this.loadImages();
        }
      }

      /* Images that are clipped sideways would only start loading when they slide into view. */
      loadImages() {
        if (this.imagesLoaded) return;
        this.imagesLoaded = true;
        this.marquee.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      }

      disconnectedCallback() {
        if (this.marquee && this.onPointerUp) this.marquee.removeEventListener('pointerup', this.onPointerUp);
        if (this.marquee && this.onPointerOver) this.marquee.removeEventListener('pointerover', this.onPointerOver);
        if (this.observer) this.observer.disconnect();
        this.ready = false;
      }
    }

    window.customElements.define('product-carousel-marquee', ProductCarouselMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!('customElements' in window) || window.customElements.get('product-recommendations')) return;

    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-recs-track]') || this.loading) return;
        const url = this.dataset.url;
        if (!url) return;

        if (!('IntersectionObserver' in window)) {
          this.load(url);
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load(url);
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      load(url) {
        this.loading = true;
        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(new Error(String(response.status)))))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.querySelector('[data-recs-track] > li')) {
              this.innerHTML = fresh.innerHTML;
              this.classList.add('is-loaded');
            } else {
              this.hide();
            }
          })
          .catch(() => this.hide())
          .finally(() => {
            this.loading = false;
          });
      }

      hide() {
        this.innerHTML = '';
        this.hidden = true;
      }
    }

    window.customElements.define('product-recommendations', ProductRecommendations);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!('customElements' in window) || window.customElements.get('product-showcase')) return;

    /* Tabs with WAI-ARIA semantics: click, Arrow keys (wrap), Home/End, automatic activation. */
    class ProductShowcase extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.onClick = (event) => {
          const tab = event.target instanceof Element ? event.target.closest('[data-showcase-tab]') : null;
          if (tab && this.contains(tab)) this.select(tab, false);
        };
        this.onKeydown = (event) => {
          const tab = event.target instanceof Element ? event.target.closest('[data-showcase-tab]') : null;
          if (!tab || event.altKey || event.ctrlKey || event.metaKey) return;
          const tabs = this.tabs();
          const index = tabs.indexOf(tab);
          if (index < 0) return;
          const rtl = window.getComputedStyle(tab).direction === 'rtl';
          let next = null;
          if (event.key === 'ArrowRight') next = tabs[(index + (rtl ? -1 : 1) + tabs.length) % tabs.length];
          else if (event.key === 'ArrowLeft') next = tabs[(index + (rtl ? 1 : -1) + tabs.length) % tabs.length];
          else if (event.key === 'Home') next = tabs[0];
          else if (event.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          this.select(next, true);
        };
        // Theme editor: show the panel of the tab block that is selected in the sidebar.
        this.onBlockSelect = (event) => {
          const tab = event.target instanceof Element ? event.target.closest('[data-showcase-tab]') : null;
          if (tab && this.contains(tab)) this.select(tab, false);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.ready = false;
      }

      tabs() {
        return Array.from(this.querySelectorAll('[data-showcase-tab]'));
      }

      select(tab, focus) {
        this.tabs().forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.setAttribute('tabindex', active ? '0' : '-1');
          item.classList.toggle('is-active', active);
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
        this.revealTab(tab);
      }

      /** Keeps the active tab visible when the segmented control scrolls on small screens. */
      revealTab(tab) {
        const list = tab.parentElement;
        if (!list || list.scrollWidth <= list.clientWidth + 1) return;
        const listRect = list.getBoundingClientRect();
        const rect = tab.getBoundingClientRect();
        if (rect.left < listRect.left) list.scrollLeft -= listRect.left - rect.left + 8;
        else if (rect.right > listRect.right) list.scrollLeft += rect.right - listRect.right + 8;
      }
    }

    window.customElements.define('product-showcase', ProductShowcase);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs')) {
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        if (this.tabsReady) return;
        this.tabsReady = true;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        if (this.tabs.length < 2) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, false));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.onBlockSelect = (event) => {
          const target = event.target instanceof Element ? event.target : null;
          const tab = target ? target.closest('[role="tab"]') : null;
          if (!tab || !this.contains(tab)) return;
          this.select(this.tabs.indexOf(tab), false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.tabsReady = false;
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next = null;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = index === last ? 0 : index + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = index === 0 ? last : index - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }
        event.preventDefault();
        this.select(next, true);
      }

      select(index, moveFocus) {
        if (index < 0 || index >= this.tabs.length) return;
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          tab.classList.toggle('is-active', active);
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
        const tab = this.tabs[index];
        if (moveFocus) tab.focus();
        const list = tab.parentElement;
        if (list && list.scrollWidth > list.clientWidth) {
          const left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
          list.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
        }
      }
    }

    customElements.define('product-tabs', ProductTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
